export enum ApiErrorCodes {
  AUTHENTICATION_ERROR = 'authentication_error',
  INVALID_CREDENTIALS = 'invalid_credentials',
  UNAUTHORIZED = 'unauthorized',
  FORBIDDEN = 'forbidden',

  EXTERNAL_SERVICE_DISABLED = 'external_service_disabled',

  OBJECT_ALREADY_EXISTS = 'object_already_exists',
  OBJECT_CREATION_FAILED = 'object_creation_failed',
  OBJECT_DELETION_FAILED = 'object_deletion_failed',
  OBJECT_DUPLICATED = 'object_duplicated',
  OBJECT_UDPATE_FAILED = 'object_update_failed',
  OBJECT_NOT_FOUND = 'object_not_found',
  OBJECT_EXPIRED = 'object_expired',
  OBJECT_USED = 'object_used',
  OBJECT_CANCELED = 'object_canceled',
  OBJECT_FORBIDDEN = 'object_forbidden',

  ATTRIBUTE_MISSING = 'attribute_missing',

  BAD_COOKIES = 'bad_cookies',
  BAD_PARAMETER = 'bad_parameter',
  BAD_QUERY = 'bad_query',
  BAD_REQUEST = 'bad_request',

  UNPROCESSABLE_ENTITY_EXCEPTION = 'unprocessable_entity_exception',
  TOO_MANY_REQUESTS = 'too_many_requests',

  EMAIL_SERVICE = 'email_service',
  FILE_DOWNLOAD_FAILED = 'file_download_failed',
  FILE_UPLOAD_FAILED = 'file_upload_failed',
  FILE_DELETE_FAILED = 'file_delete_failed',
  FILE_SIGNATURE_FAILED = 'file_signature_failed',
}
